import 'babel-polyfill';

window._ = require('lodash');
window.Popper = require('popper.js').default;
import {alertMessages, alertValidationErrorMessages} from './utils/htmlUtils';
import {
    HTTP_UNAUTHORIZED,
    HTTP_FORBIDDEN,
    PRIVATE_LINE_TALK,
    ADMIN,
    PERMISSIONS,
    TIME_LOAD_MESSAGE,
    HTTP_PAGE_EXPIRED
} from './constants';
import axios from 'axios';

/**
 * Change unread access every 60 seconds
 */
let unreadRunFlg = false;
const intervalId = setInterval(() =>{
    if (unreadRunFlg) {
        updatePrivateTalkUnread();
        unreadRunFlg = false;
    }
}, 60000);

function setUnreadRunFlg() {
    unreadRunFlg = true;
}

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = $;
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a comworkspace/app/Providers/AppServiceProvider.phpn header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    axios.interceptors.response.use((response) => {
        return response;
    }, (error) => {
        switch (window._.get(error, 'response.status')) {
            case HTTP_UNAUTHORIZED: {
                window.location.reload();
                break;
            }
            case HTTP_PAGE_EXPIRED: {
                window.location.reload();
                break;
            }
            case HTTP_FORBIDDEN: {
                const title = window.Lang.get('common.title_error_not_permission');
                const messages = window.Lang.get('common.text_error_not_permission');
                alertMessages({title, messages}, () => {
                    window.location.reload();
                });
                return;
            }
            default: {
                break;
            }
        }

        return Promise.reject(error);
    });
    // window.$.ajaxSetup({
    //     headers: {
    //         'X-CSRF-TOKEN': token.content,
    //     }
    // });
} else {
    // eslint-disable-next-line
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.axios = axios.create();

window.$('[data-toggle="tool-tip"]').tooltip();
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo';

window.io = require('socket.io-client');

function setNumberStudentInTodoList(num) {
    let countText = num > 0 ? num + Lang.get('common.text_person') : '';
    if (num >= 100) {
        countText = '99+';
    }

    if (window.location.href.includes(window.laroute.route('private_line_talk')) && window.is_domain_aura) {
        let countMessageUnread = num > 0
            ? '(' + (num >= 100 ? '99+' : num)  + ')'
            : '';
        document.title = countMessageUnread + document.title.replace(document.title, Lang.get('common.page_title.private_line_talk'));
    }
    window.$('#private-line-talk-counter').text(countText);
    window.$('#js-total-student-unread').text(countText);
    window.$('#js-total-student-unread').parent().css('opacity', 1);
    if (!window.$('#js-total-student-unread').text()) {
        window.$('#js-total-student-unread').parent().css('opacity', 0);
    }
}
function setNumberTalkInTodoList(num) {
    if (window.location.href.includes(window.laroute.route('group_line_talk')) && window.is_domain_aura) {
        let countMessageUnread = num > 0
            ? `(${num})`
            : '';
        document.title = countMessageUnread + document.title.replace(document.title, Lang.get('common.page_title.group_line_talk'));
    }
    let countText = num > 0 ? num + Lang.get('common.text_person') : '';

    window.$('#group-line-talk-counter').text(countText);
    window.$('#js-total-talk-unread').text(countText);
    window.$('#js-total-talk-unread').parent().css('opacity', 1);
    if (!window.$('#js-total-talk-unread').text()) {
        window.$('#js-total-talk-unread').parent().css('opacity', 0);
    }
}
function updatePrivateTalkUnread() {
    const url = '/private-line-talk/unread';
    const headers = {
        allowBlur: false,
        isShowLoadingView: false
    };

    // Check if studentIds is in current category settings
    window.axios.get(url, {headers})
        .then((response) => {
            const unread = response.data;
            setNumberStudentInTodoList(unread);
        });
}
function updateGroupTalkUnread() {
    const url = '/group-line-talk/unread';
    const headers = {
        allowBlur: false,
        isShowLoadingView: false
    };

    // Check if studentIds is in current category settings
    window.axios.get(url, {headers})
        .then((response) => {
            const unread = response.data;
            setNumberTalkInTodoList(unread);
        });
}
function handleIncomingMessage(message) {
    if (hasPermission([PERMISSIONS['PRIVATE_TALK_READ'], PERMISSIONS['PRIVATE_TALK_WRITE']])) {
        const currentUnread = window.$('#private-line-talk-counter')
            .text()
            .trim()
            .replace(Lang.get('common.text_person'), '');
        // If message is from me or currentUnread > 99 => no need to check unread
        if (!message || message.is_from_me || currentUnread === '99+') {
            return;
        }
        setUnreadRunFlg();
    }
}
function handleIncomingTalkMessage(message) {
    if (hasPermission([PERMISSIONS['PRIVATE_TALK_READ'], PERMISSIONS['PRIVATE_TALK_WRITE']])) {
        const currentUnread = window.$('#group-line-talk-counter')
            .text()
            .trim()
            .replace(Lang.get('common.text_person'), '');
        // If message is from me or currentUnread > 99 => no need to check unread
        if (!message || message.is_from_me || currentUnread === '99+') {
            return;
        }
        updateGroupTalkUnread();
    }
}

function hasPermission (allowedPermission) {
    if (!window.Laravel.roles) {
        return false;
    }

    const userType = window.Laravel.roles.type;
    const permissions = Object.values(window.Laravel.roles.data);

    if (userType == null) {
        return false;
    }

    if (userType == ADMIN) {
        return false;
    }

    const permissionStaff = permissions.find(function (e) {
        return allowedPermission.includes(e.name);
    });

    if (permissionStaff) {
        return true;
    }

    return false;
}

if (typeof window.Laravel !== 'undefined' && window.Laravel.userId) {
    const socketUrl = process.env.SOCKET_URL;
    let echoHost = window.location.hostname;


    if (socketUrl != '') {
        echoHost = socketUrl;
    }

    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: echoHost
    });

    // When receive new message
    window.Echo.channel(`private-company-user.${window.Laravel.companyUserId}`)
        .listen('.message.created', ({message}) => {
            handleIncomingMessage(message);
        })
        .listen('.ms_message.received', ({message}) => {
            handleIncomingMessage(message);
        })
        .listen('.talk-message.created', ({message}) => {
            handleIncomingTalkMessage(message);
        });


    if (hasPermission([PERMISSIONS['PRIVATE_TALK_READ'], PERMISSIONS['PRIVATE_TALK_WRITE']])) {
        // When update message status
        window.Echo.channel(`private-user.${window.Laravel.userId}`)
            .listen('.status.updated', (e) => {
                if (e.privateTalks) {
                    const markId = e.privateTalks.mark_id;
                    if (markId === PRIVATE_LINE_TALK.STATUS.TODO) {
                        return;
                    }
                    setUnreadRunFlg();
                }
            })
            .listen('.talk-status.updated', (e) => {
                if (e.groupTalks) {
                    const markId = e.groupTalks.mark_id;
                    if (markId === PRIVATE_LINE_TALK.STATUS.TODO) {
                        return;
                    }
                    updateGroupTalkUnread();
                }
            });

        // When receive new message
        window.Echo.channel(`private-company-user.${window.Laravel.companyUserId}`)
            .listen('.message.created', (e) => handleIncomingMessage(e.message))
            .listen('.talk-message.created', (e) => handleIncomingTalkMessage(e.message));
    }

    window.Echo.channel(`private-export-csv.${window.Laravel.userId}`)
        .listen('.export-csv.success', (e) => {
            $.notify({
                message: _.escape(e.historyExport.file_name) + window.Lang.get('history_download_file.export_successful'),
                url: laroute.route('users.history_download_files.index'),
                target: '_blank'
            }, {
                type: 'success',
                placement: {
                    from: 'bottom',
                    align: 'right'
                },
            });
        });

    window.Echo.channel(`private-reload-company-and-staff-page.${window.Laravel.companyUserId}`)
        .listen('.company-and-staff.reload-page', (e) => {
            if (e.mustReloadIds.indexOf(window.Laravel.userId) > -1) {
                window.location.reload();
            }
        });

    window.Echo.channel(`private-update-role.${window.Laravel.companyUserId}`)
        .listen('.role.updated', (e) => {
            if (window.Laravel.roles.type === 'staff' && e.staffIds.indexOf(window.Laravel.userId) > -1) {
                window.location = window.laroute.route('logout');
            }
        });
    window.Echo.channel(`private-force-logout.${window.Laravel.companyUserId}`)
        .listen('.force.logout', (e) => {
            if (window.Laravel.userId == e.userId) {
                window.location = window.laroute.route('logout');
            }
        });
}

